import { useState } from 'react'
import { Link } from 'react-router-dom'

import type { Uebersicht } from '../typen'

/**
 * Rückfragen, die beim Buchen ohne Antwort geschlossen wurden (02.11.2026, `rueckfragen_uebergangen`, letzte 14 Tage).
 * Sie sind nicht offen und zählen nirgends mit - aber eine Erklärung, die inzwischen im Gespräch fiel, lässt sich
 * nachtragen (Frau Barths Erklärung zu 920630 ging am 23.09. genau so verloren). Darum eingeklappt und leise.
 */
export default function UebergangeneRueckfragen({ uebersicht }: { uebersicht: Uebersicht | null }) {
  const [offen, setOffen] = useState(false)
  const fragen = uebersicht?.rueckfragen_uebergangen ?? []
  if (fragen.length === 0) return null
  return (
    <div className={`karte${offen ? '' : ' eingeklappt'}`} id="rueckfragen-uebergangen">
      <div className="leiste">
        <b>Beim Buchen übergangen</b>
        <span className="hinweis">
          {fragen.length === 1 ? 'Eine Rückfrage' : `${fragen.length} Rückfragen`} der letzten 14 Tage blieb ohne Antwort, als ihr
          Lauf gebucht wurde - zum Nachlesen, eine Antwort lässt sich nachtragen.
        </span>
        <button className="leise" aria-expanded={offen} onClick={() => setOffen((o) => !o)}>
          {offen ? 'ausblenden' : 'anzeigen'}
        </button>
      </div>
      {offen && (
        <>
          <ul className="befund-liste">
            {fragen.map((f) => (
              <li key={f.id} className="befund hinweis">
                <span className="status verworfen">übergangen</span>
                <div className="befund-text">
                  <div>{f.frage}</div>
                  {f.import_lauf_id !== null && (
                    <Link className="hinweis-link" to={`/importe/${f.import_lauf_id}`}>
                      Lauf {f.import_lauf_id}
                    </Link>
                  )}
                </div>
              </li>
            ))}
          </ul>
          <Link className="knopf" to="/rueckfragen#uebergangen">
            Antwort nachtragen
          </Link>
        </>
      )}
    </div>
  )
}
